<template>
<transition-group name="fadeDown" mode="out-in" tag="div" id="inventoryList" >
  <table v-bind:key="'setupAlerts'" class="ui very compact table" style="border-bottom-left-radius: 0;border-bottom-right-radius: 0;">
    <tr>
      <td>

        <div class="ui accordion">
          <div class="title">
            <i class="dropdown icon"></i>
            Setup FBA Inventory Alerts
          </div>
          <div class="content" style="height:195px; overflow:hidden;">
            <SpreadsheetConfig v-bind:watch-dog-name="'FBA Inventory'" v-bind:api-prefix="'inventory'"/>
          </div>
        </div>

      </td>
    </tr>

    <tr>
      <td>

        <div class="ui accordion">
          <div class="title">
            <i class="dropdown icon"></i>
            Setup FBM Inventory Alerts
          </div>
          <div class="content" style="height:195px; overflow:hidden;">
            <SpreadsheetConfig v-bind:watch-dog-name="'FBM Inventory'" v-bind:api-prefix="'fbm_inventory'"/>
          </div>
        </div>

      </td>
    </tr>

    <tr>
      <td>

        <div class="ui accordion">
          <div class="title">
            <i class="dropdown icon"></i>
            Setup Sales Volume Alerts
          </div>
          <div class="content" style="height:195px; overflow:hidden;">
            <SpreadsheetConfig v-bind:watch-dog-name="'Sales Volume'" v-bind:api-prefix="'salesdrop'"/>
          </div>
        </div>

      </td>
    </tr>
  </table>

  <div v-bind:key="'productsStock'" class="horizontal-scroll-container" style="overflow: auto;" >
    <table class="ui very compact table" style="border-top-left-radius: 0;border-top-right-radius: 0;background-color: transparent;">
      <tr class=""
          v-for="product in sortedUnfoldedProducts"
          v-if="($parent.filterByMarket.length==0||$parent.filterByMarket.indexOf(product.marketplace)>=0)&&($parent.filterBySellAcc.length==0||$parent.filterBySellAcc.indexOf(product.sellerId)>=0)&&$parent.$parent.worldStore.watchDogs.inventory.items[product.productId]"
          v-bind:key="product.productId"
          :set="fbmItem = getFbmItem(product.productId)"
      >


        <td class="ui collapsing " >
          <i :class="''+product.marketplace.toLowerCase().replace('uk','gb')+' flag'"></i>
          <small>
            <a href="#" @click.prevent="showProductDetails(product.productId)" qqstyle="text-decoration:underline;">
              {{ product.productUrl.replace(/.*\/dp\/([a-zA-Z0-9]*)\?*.*/gi, "$1") }}
            </a>
          </small>
        </td>


        <td class="ui collapsing" >
          <img :src="product.largeImageUrl" class="ui image tiny" @click.prevent="showProductDetails(product.productId)" style="cursor:pointer;">
        </td>


        <td class=" four wide " >
          <div style="max-height:5.5em; overflow:hidden;">
            {{product.productTitle}}
          </div>
        </td>



        <!-- sales section -->
        <td class="collapsing" v-if="product.ageHours > -1" style="line-height:1.8em;">
          <div @click.stop.prevent="$parent.$parent.$refs.chartModal.open(product, null)"
               class="salesQuickInfo"
               style="cursor:pointer;"
               :data-html="'<img src=\'/api/sentinel/watchdog/salesdropchart/'+$parent.$parent.worldStore.watchDogs.salesDrop.items[product.productId].watchDogId+'\' style=\'height:200px;\'/>'"
          >
            <strong>{{product.salesYesterday}}</strong>&nbsp; units sold ystd. <br>
            <strong>{{product.salesToday}}</strong>&nbsp; so far today ({{product.marketplace}})
          </div>

        </td>
        <td class="" v-else>
          <i style="margin-right: 1px;" class="dollar icon"></i>
          Sales data not avail. yet
        </td>



        <!-- FBA stock section -->
        <td class="collapsing">
          <i class="large icons"
             v-if="$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.indexOf('No alert thres')>=0"
             data-tooltip="No alert thresholds have been set yet. Use setup at the top."
          >
            <i class="warehouse grey icon" style="opacity:.4;"></i>
            <i class="yellow inverted corner exclamation triangle icon" style="opacity:.4;"></i>
          </i>

          <i v-else-if="$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status==0"
             class="large green checkmark icon">
          </i>

          <i v-else-if="$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status==1"
             class=""
          >
            <i class="large orange exclamation triangle icon"></i>
          </i>

          <i v-else-if="$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status==2"
             class=""
          >
            <i class="large red exclamation triangle icon"></i>
          </i>
        </td>


        <td class="collapsing" >
          <div style="line-height:1.5em;" v-if="product.inboundQty>0">
            FBA Total inv.:&nbsp; <strong>{{product.totalQty}}</strong> <br>
            FBA Available:        <strong>{{product.inStockQty}}</strong> <br>
            FBA Inbound: &nbsp;   <strong>{{product.inboundQty}}</strong>
          </div>
          <div style="line-height:1.8em;" v-else>
            FBA Total inv.:&nbsp; <strong>{{product.totalQty}}</strong> <br>
            FBA Available:        <strong>{{product.inStockQty}}</strong>
          </div>

        </td>



        <td class="collapsing" v-if="$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status>0">

        <span style="color:#b33;"
              v-if="$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && $parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.indexOf('No alert thres')===-1"
              v-html="$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/^[^(]*\(/, '').replace(/\)$/, '').replace(/(\d+)/gi, '<b style=\'color:#444;\'>$1</b>').replace('; est.','.<br>Est.')">
        </span>
          <span style="color:#b33;"
                v-else-if="product.totalQty==0">
          Out of Stock
        </span>
        </td>
        <td class="collapsing" v-else-if="$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.match(/.*days left.*/)" >
          <h3 class="ui header">
          <span style="color:purple;">
            {{$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/.*days left: (\d*).*/, '$1')}}
          </span> days left
            <div class="sub header">
              based on last
              {{$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].settings.velocityLookbackDays}}d
            </div>
          </h3>
        </td>


        <!-- FBM stock section -->
        <td class="collapsing">
          <i class="large icons"
             v-if="fbmItem === null || fbmItem.alertThreshold === null"
             data-tooltip="No alert thresholds have been set yet. Use setup at the top."
          >
            <i class="warehouse grey icon" style="opacity:.4;"></i>
            <i class="yellow inverted corner exclamation triangle icon" style="opacity:.4;"></i>
          </i>

          <i v-else-if="!fbmItem.hasIssue"
             class="large green checkmark icon">
          </i>
          <i v-else class="">
            <i class="large red exclamation triangle icon"></i>
          </i>
        </td>

        <td class="collapsing" style="padding-right:30px;">
          <div style="line-height:1.8em;" v-if="fbmItem">
            FBM Total inv.:&nbsp;&nbsp;&nbsp; <strong>{{product.fbmQty ? product.fbmQty : 0}}</strong> <br>
            <span v-if="fbmItem.alertThreshold">FBM Threshold:        <strong>{{fbmItem.alertThreshold}}</strong></span>
          </div>
        </td>

      </tr>
    </table>
  </div>

</transition-group>
</template>

<script>
import $ from 'jquery'
import SpreadsheetConfig from './settings/SpreadsheetConfig'
export default {
  components: {
    SpreadsheetConfig
  },
  data: function () {
    return {
      reds: {},
      ambers: {},
      productGroupId2products: {},
      productGroupIds: [],
      groupedProducts: [],
      sortedUnfoldedProducts: [],
    }
  },
  props: [],
  methods: {
    toMonth: (m) => ({1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'}[m]),
    salesCountTotal: function (productIds, t) {
      const getSales = id => this.$parent.$parent.worldStore.products[id].sales
      if (t === 'y') return productIds.reduce((prevVal, id) => prevVal + (getSales(id) !== null ? getSales(id)[1].unitsSold : Number.NaN), 0)
      if (t === 't') return productIds.reduce((prevVal, id) => prevVal + (getSales(id) !== null ? getSales(id)[0].unitsSold : Number.NaN), 0)
    },
    showProductDetails: function (productId) {
      this.$parent.openProductDetailModal(this.sortedUnfoldedProductsIDs, this.sortedUnfoldedProductsIDs.indexOf(productId))
    },
    starCalc: function (r, m) {
      const div = Math.floor(r / 10)
      const mod = r % 10
      if (m === 'f') return mod <= 7 ? div : div + 1
      if (m === 'h') return Math.abs(mod - 5) <= 2 ? 1 : 0
      if (m === 'e') return 5 - div - (mod > 2 ? 1 : 0)
    },
    calc: function (worldStore) {
      const productGroupId2productIds = this.getProductGroupId2productIds(worldStore.products)
      const productId2ProductGroupId = this.getProductId2ProductGroupId(worldStore.products)
      const productGroupIds = Object.keys(productGroupId2productIds)
      const amberErrorCount = this.getErrorCount(productGroupIds, 1, worldStore.watchDogs, worldStore.products, productId2ProductGroupId)
      const redErrorCount = this.getErrorCount(productGroupIds, 2, worldStore.watchDogs, worldStore.products, productId2ProductGroupId)
      this.reds = redErrorCount.byProductGroupId
      this.ambers = amberErrorCount.byProductGroupId
      const productGroupId2products = {}
      for (let i = 0; i < productGroupIds.length; ++i) {
        const productGroupId = productGroupIds[i]
        const productIdsForProductGroupId = productGroupId2productIds[productGroupId]
        productGroupId2products[productGroupId] = (this.productGroupId2products.hasOwnProperty(productGroupId)
          ? this.addKeepingOrder(this.productGroupId2products[productGroupId].map(p => p.productId), productGroupId2productIds[productGroupId])
          : productIdsForProductGroupId.sort((a, b) => {
            const redA = redErrorCount.byProductId[a]
            const redB = redErrorCount.byProductId[b]
            const amberA = amberErrorCount.byProductId[a]
            const amberB = amberErrorCount.byProductId[b]
            let compResult = redB - redA
            if (compResult !== 0) return compResult
            return amberB - amberA
          })).map(pid => worldStore.products[pid])
      }
      this.productGroupId2products = productGroupId2products
      this.productGroupIds = productGroupIds.sort((a0, b0) => {
        const a = productGroupId2products[a0][0]
        const b = productGroupId2products[b0][0]
        let compResult = b.marketplace.localeCompare(a.marketplace)
        if (compResult !== 0) return compResult
        return a.productTitle.localeCompare(b.productTitle)
      })
      let sortedUnfoldedProductsIDs = []
      for (let i = 0; i < this.productGroupIds.length; ++i) {
        sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs.concat(productGroupId2products[this.productGroupIds[i]].map(p => p.productId))
      }
      this.sortedUnfoldedProductsIDs = sortedUnfoldedProductsIDs
      this.groupedProducts = this.productGroupIds.map(pgid => this.productGroupId2products[pgid][0])
      this.sortedUnfoldedProducts = this.sortedUnfoldedProductsIDs.map(pgid => this.$parent.$parent.worldStore.products[pgid])
      // console.log(sortedUnfoldedProductsIDs)
    },
    getProductGroupId2productIds: function (products) {
      const productGroupId2productIds = {}
      const productValues = Object.values(products)
      for (let i = 0; i < productValues.length; ++i) {
        const product = productValues[i]
        if (productGroupId2productIds[product.productGroupId]) {
          productGroupId2productIds[product.productGroupId].push(product.productId)
        } else {
          productGroupId2productIds[product.productGroupId] = [product.productId]
        }
      }
      return productGroupId2productIds
    },
    getProductId2ProductGroupId: function (products) {
      const result = {}
      const productValues = Object.values(products)
      for (let i = 0; i < productValues.length; ++i) {
        const product = productValues[i]
        result[product.productId] = product.productGroupId
      }
      return result
    },
    getErrorCount: function (productGroupIds, issueStatus, watchDogs, products, productId2ProductGroupId) {
      const productIds = Object.keys(products)
      const errorCountByProductGroupId = {}
      const errorCountByProductId = {}
      for (let i = 0; i < productGroupIds.length; ++i) {
        errorCountByProductGroupId[productGroupIds[i]] = new Set()
      }
      for (let i = 0; i < productIds.length; ++i) {
        errorCountByProductId[productIds[i]] = new Set()
      }
      const watchDogKeys = Object.keys(watchDogs)
      for (let i = 0; i < watchDogKeys.length; ++i) {
        const fullKey = watchDogKeys[i]
        const watchDog = watchDogs[fullKey]
        const watchDogName = fullKey.split('_')[0]
        if (watchDog.status === 20 || watchDog.status === 21) continue
        // With flat structure, each watchDog IS an item
        const items = [watchDog]
        for (let j = 0; j < items.length; ++j) {
          const item = items[j]
          if (Array.isArray(item)) {
            for (let k = 0; k < item.length; ++k) {
              const item0 = item[k]
              if (item0.issueStatus === 0 && !item0.muted && item0.status === issueStatus) {
                if (item0.productGroupId && errorCountByProductGroupId[item0.productGroupId]) {
                  errorCountByProductGroupId[item0.productGroupId].add(watchDogName)
                } else if (item0.productId && productId2ProductGroupId[item0.productId]) {
                  errorCountByProductGroupId[productId2ProductGroupId[item0.productId]].add(watchDogName)
                }
                if (item0.productId) {
                  errorCountByProductId[item0.productId].add(watchDogName)
                }
              }
            }
          } else {
            if (item.issueStatus === 0 && !item.muted && item.status === issueStatus) {
              if (item.productGroupId) {
                errorCountByProductGroupId[item.productGroupId].add(watchDogName)
              } else if (item.productId && productId2ProductGroupId[item.productId]) {
                errorCountByProductGroupId[productId2ProductGroupId[item.productId]].add(watchDogName)
              }
              if (item.productId) {
                errorCountByProductId[item.productId].add(watchDogName)
              }
            }
          }
        }
      }
      const resultByProductId = {}
      const resultByProductGroupId = {}
      for (let i = 0; i < productIds.length; ++i) {
        resultByProductId[productIds[i]] = errorCountByProductId[productIds[i]].size
      }
      for (let i = 0; i < productGroupIds.length; ++i) {
        resultByProductGroupId[productGroupIds[i]] = errorCountByProductGroupId[productGroupIds[i]].size
      }
      return {
        byProductId: resultByProductId,
        byProductGroupId: resultByProductGroupId,
      }
    },
    addKeepingOrder: function (base0, addition0) {
      const base = base0 || []
      const addition = addition0 || []
      const result = []
      for (let i = 0; i < base.length; ++i) {
        if (addition.indexOf(base[i]) >= 0) result.push(base[i])
      }
      const addition2 = []
      for (let i = 0; i < addition.length; ++i) {
        if (base.indexOf(addition[i]) < 0) addition2.push(addition[i])
      }
      const addition3 = addition2.sort()
      for (let i = 0; i < addition3.length; ++i) {
        result.push(addition3[i])
      }
      return result
    },
    getFbmItem: function (productId) {
      const item = this.$parent.$parent.worldStore.watchDogs.fbmInventory.items[productId]
      if (!item) return null
      const msg = item.statusDetails.message
      const isBelowThreshold = msg.indexOf('Below the alert threshold of') > -1
      const isAtThreshold = msg.indexOf('At the alert threshold of') > -1
      const isOutOfStock = msg.indexOf('ut of stock') > -1
      const alertThresholdIdx = msg.indexOf('alert threshold of')
      let alertThreshold = null
      if (alertThresholdIdx > -1) {
        const alertThreshold0 = msg.substring(alertThresholdIdx + 19)
        const alertThreshold0Idx = alertThreshold0.indexOf(')')
        alertThreshold = alertThreshold0.substring(0, alertThreshold0Idx > -1 ? alertThreshold0Idx : alertThreshold0.length)
      }
      return {hasIssue: isBelowThreshold || isAtThreshold || isOutOfStock, alertThreshold: alertThreshold}
    },
  },
  computed: {
    getCardsLayoutSize: function () {
      const n = this.productGroupIds.length
      const w = $(window).width()

      if (n > 4) return w > 1320 ? 'five' : 'four'
      if (n === 4) return w > 1220 ? 'four' : 'three'
      else return w > 1440 ? 'four' : 'three'
    },
  },
  mounted: function () {
    $(this.$el).find('.salesQuickInfo').popup({ delay: { show: 0, hide: 0 }, transition: 'fade', position: 'left center' })
    $('#darkbackgr').stop().fadeOut(200) // in case animation didnt finish in WD view before switching
    $('#inventoryList .ui.accordion').accordion()
  },
  updated: function () {
    // new products might have appeared - attach popups again
    $(this.$el).find('.salesQuickInfo').popup({ delay: { show: 0, hide: 0 }, transition: 'fade', position: 'left center' })
  },
  watch: {
    '$parent.$parent.worldStore': {
      handler: function (worldStore) {
        this.calc(worldStore)
      },
      deep: true,
    },
  },
  created: function () {
    if (this.$parent.$parent.worldStore) {
      this.calc(this.$parent.$parent.worldStore)
    }
  },
}
</script>

<style>
.flip-list-move {
  transition: transform 1s;
}
#prodCont .ui.segment:first-child {margin-top:12px;}
#prodCont .ui.segment:last-child {margin-bottom:12px;}
/* #prodCont .ui.segment.stacked .extra.content:last-child {padding-bottom:0px;} */

#prodCont .extra.content .chartbutton {opacity:.6; padding: 7px 11px;}
#prodCont .extra.content .chartbutton:hover {opacity:1 !important;}

#prodCont .card:hover {z-index: initial; -webkit-transform: translateY(-2px); transform: translateY(-2px); transition: all 0s;}

#inventoryList .ui.very.compact.table {
  margin: 0;
}

.horizontal-scroll-container {
  background:
    linear-gradient(to right,
    white 30%,
    rgba(255, 255, 255, 0)
    ) left/40px 100% no-repeat local,
    linear-gradient(to left,
    white 70%,
    rgba(255, 255, 255, 0)
    ) right/40px 100% no-repeat local,

    linear-gradient(
      to right,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0)
    ) left/10px 100% no-repeat scroll,
    linear-gradient(
      to left,
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0)
    ) right/10px 100% no-repeat scroll,

    white;
}

.horizontal-scroll-container td {
  mix-blend-mode: multiply;
}
</style>



// WEBPACK FOOTER //
// InventoryList.vue?13b28e04